export default __webpack_public_path__ + "static/media/firm.5e34904d.svg";